<template>
    <span class="required-label">*</span>
</template>

<script>

</script>

<style scoped>
    .required-label {
        color: #ff0000;
        padding-left: 3px;
    }
</style>